import React, { useRef } from 'react';

import { Draggable } from '../Draggable';
import { Icon, IconSize } from '../Icon';
import * as S from './carousel.styles';
import { CarouselProps } from './carousel.types';

import ChevronLeft from '@/icons/chevron_left.icon.svg';
import ChevronRight from '@/icons/chevron_right.icon.svg';

export const Carousel: React.FC<CarouselProps> = ({ dragData, images, disabled }) => {
  const carouselRef = useRef<HTMLDivElement>(null);
  function handleScroll(direction: 'left' | 'right') {
    if (!carouselRef.current) return;
    const currentScrollPosition = carouselRef.current.scrollLeft;
    if (direction === 'left') {
      carouselRef.current.scrollTo(currentScrollPosition - 300, 0);
    } else if (direction === 'right') {
      carouselRef.current.scrollTo(currentScrollPosition + 300, 0);
    }
  }

  return (
    <S.Container>
      <S.Carousel ref={carouselRef} isDisabled={disabled}>
        {!disabled && images.length > 1 && (
          <>
            <S.Button direction="left" onClick={() => handleScroll('left')}>
              <Icon icon={ChevronLeft} size={IconSize.S} />
            </S.Button>
            <S.Button direction="right" onClick={() => handleScroll('right')}>
              <Icon icon={ChevronRight} size={IconSize.S} />
            </S.Button>
          </>
        )}

        {images.map((image, idx) => {
          if (!dragData) return <S.Thumbnail key={idx} src={image} />;
          return (
            <Draggable data={{ ...dragData }} key={idx}>
              <S.Thumbnail src={image} />
            </Draggable>
          );
        })}
      </S.Carousel>
    </S.Container>
  );
};
